module.exports = __webpack_public_path__ + "img/greater-than.a3be2d4f.svg";